import Vue from 'vue';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const report = data;
  resolve(report);
};

const failed = (error, reject) => reject(error);


export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/excise_entries/flag', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/exciseEntry/checkFlag.js